import { useQuery } from '@tanstack/react-query';

import { fetchSchedulesDates } from 'api/photo-session';

export const getKey = (propertyId, agentUserId) => [
  'schedules-dates',
  Number(propertyId),
  agentUserId == null ? null : Number(agentUserId),
];

// Fresh on every mount; no refetch on focus, which would change the list under an ongoing selection.
// `agentUserId`:
//  - `undefined` means the caller isn't ready yet (e.g. still resolving which agent to filter by); disables
//    the query so we don't fetch with the wrong filter and then have to discard it.
//  - `null` means the caller is ready and wants the unfiltered, region-wide availability on purpose.
//  - a number filters the availability down to that single agent.
const useSchedulesDates = (propertyId, agentUserId, options) =>
  useQuery({
    queryKey: getKey(propertyId, agentUserId),
    queryFn: () => fetchSchedulesDates(propertyId, agentUserId),
    enabled: !!propertyId && agentUserId !== undefined,
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    // The agent filter can change (e.g. the keep-session toggle) without unmounting the screen; keep
    // showing the previous list (isLoading stays false) while the new one loads in the background
    // (isFetching), instead of blanking the whole form.
    keepPreviousData: true,
    ...options,
  });

export default useSchedulesDates;
